import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { authApi } from '../auth';
import { STAFF_RESEND_INVITE } from 'config/apiPaths';

export const supportStaffApi = createApi({
    reducerPath: 'supportStaffApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/support-staff",
    }),
    tagTypes: ["SupportStaff"],
    endpoints: (builder) => ({
        getSupportStaffData: builder.query({
            query: ({ page = 1, limit = 10, search = "", plan_client_type = "", status = "", school = "", support_staff = "", sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `/list`,
                data: { page, limit, sort, search, status: status?.value, school: school?.value, support_staff: support_staff?.value, plan_client_type: plan_client_type?.value, }
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["SupportStaff"]
        }),

        getSupportStaffTaskslist: builder.query({
            query: ({ page = 1, limit = 10, status = "", search = "", grade = "", id, sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `/task_plan_lists/${id}`,
                data: { page, limit, sort, search, status: status?.value, grade: grade?.value }
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["SupportStaff"]
        }),

        ViewSupportStaff: builder.query({
            query: ({ id }) => ({
                method: "GET",
                url: `/view/${id}`
            }),
            transformResponse: (response) => {
                return response.data.record;
            },
            providesTags: ["SupportStaff"]
        }),
        CreateSupportStaff: builder.mutation({
            query: (values) => ({
                method: "POST",
                url: `/create`,
                data: values
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["SupportStaff"]
        }),
        UpdateSupportStaff: builder.mutation({
            query: ({ values, id }) => ({
                method: "PUT",
                url: `/update/${id}`,
                data: values
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["SupportStaff"]
        }),

        getSupportStaffClients: builder.query({
            query: ({ plan_client_type = "", schoolId = "" } = {}) => ({
                method: "GET",
                url: `/clients`,
                params: plan_client_type ? { plan_client_type, school_id: schoolId } : null
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["SupportStaff"]
        }),

        deleteSupportStaff: builder.mutation({
            query: ({ id }) => ({
                method: "DELETE",
                url: `/remove/${id}`,
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["SupportStaff"]
        }),

        getSingleTaskPlan: builder.query({
            query: ({ id, clientId }) => ({
                method: "GET",
                url: `/task_plan_detail/${id}/${clientId}`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["SupportStaff"]
        }),

        resendSupportStaffInvite: builder.mutation({
            query: ({ id }) => ({
                method: "PUT",
                url: `${STAFF_RESEND_INVITE}/${id}`,
            }),
            transformResponse: (response) => {
                return response;
            },
            // invalidatesTags: ["SupportStaff"]
        }),

    }),
})

export const {
    useGetSupportStaffDataQuery,
    useViewSupportStaffQuery,
    useCreateSupportStaffMutation,
    useUpdateSupportStaffMutation,
    useGetSupportStaffClientsQuery,
    useGetSupportStaffTaskslistQuery,
    useDeleteSupportStaffMutation,
    useGetSingleTaskPlanQuery,
    useResendSupportStaffInviteMutation
} = supportStaffApi;
